import get from 'lodash.get';

import { emptyArray } from '../../../default-props/empty';

export const selectSalesOrderId = (state) => get(state, 'salesOrderId');
export const selectFulfillmentPlanId = (state) => get(state, 'fulfillmentPlanId');
export const selectModalId = (state) => get(state, 'modalId');
export const selectIsCreatingReturn = (state) => get(state, 'isCreatingReturn');
export const selectIsLoading = (state) => get(state, 'isLoading');
export const selectisReturnsFromShipment = (state) => get(state, 'isReturnsFromShipment');
export const selectShipmentIdForReturns = (state) => get(state, 'shipmentIdForReturns');
export const selectSelectedReturnItems = (state) => get(state, 'selectedReturnItems', emptyArray);
export const selectInventoryInfo = (state) => get(state, 'inventoryInfo');
